"use client"

import { Toaster as Sonner, ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {

  return (
    <Sonner
      className="toaster group"
      icons={{
        success: <iconpark-icon name="fill-circle-check" size="16" className="color-green" />,
        info: <iconpark-icon name="fill-circle-info" size="16" className="color-blue" />,
        warning: <iconpark-icon name="fill-circle-warning" size="16" className="color-yellow" />,
        error: <iconpark-icon name="fill-circle-clear" size="16" className="color-red" />,
        loading: <div className="i-svg-spinners:270-ring size-4 color-brand-primary" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:px-3 group-[.toaster]:py-2 group-[.toaster]:gap-1 group-[.toaster]:bg-surface group-[.toaster]:text-primary group-[.toaster]:bor-2 group-[.toaster]:shadow-md',
          description: 'group-[.toast]:text-primary',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          success: '[&_[data-icon]]:color-green',
          warning: '[&_[data-icon]]:color-yellow',
          error: '[&_[data-icon]]:color-red',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
